import { cn } from "~/utils/helpers"

interface HakiGlowProps {
  children: React.ReactNode
  className?: string
}

export default function HakiGlow({ children, className }: HakiGlowProps) {
  return (
    <div className={cn("relative", className)}>
      <div
        aria-hidden
        className="pointer-events-none absolute -inset-2 rounded-[24px] blur-[12px] opacity-20"
        style={{
          backgroundImage: "var(--haki-brand-gradient)",
        }}
      />
      <div className="relative">{children}</div>
    </div>
  )
}
